import { Link, useLocation } from 'react-router-dom';
import { useLayout } from '../../context/LayoutContext';

// interfaces
interface IProps {
  url: string;
  icon: string | React.ReactNode;
  title: string;
  badgeCount?: number;
  badgeText?: string;
  badgeColor?: string;
  dot?: boolean;
  tooltip?: string;
}

const NavbarButton: React.FC<IProps> = ({ url, icon, title, badgeCount, badgeText, badgeColor, dot, tooltip }) => {
  const location = useLocation();
  const { closeMobileMenu, isSidebarCollapsed } = useLayout();

  // Check if current path matches this button's URL
  // For exact match on root, or check if path starts with URL followed by / or is exact match
  const isActive =
    url === '/'
      ? location.pathname === '/' || location.pathname === '/dashboard'
      : location.pathname.toLowerCase() === url.toLowerCase() ||
      location.pathname.toLowerCase().startsWith(url.toLowerCase() + '/');

  return (
    <Link
      to={url}
      className={`${isActive ? 'active nowrap' : 'passive nowrap'} ${isSidebarCollapsed ? 'collapsed-btn' : ''}`}
      onClick={closeMobileMenu}
      style={{ position: 'relative' }}
      title={tooltip}
    >
      {typeof icon === 'string' ? <i className='material-icons'>{icon}</i> : icon}
      {!isSidebarCollapsed && (
        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          {title}
          {badgeCount && badgeCount > 0 ? (
            <span style={{
              background: '#ef4444',
              color: 'white',
              fontSize: '11px',
              fontWeight: 600,
              padding: '2px 6px',
              borderRadius: '10px',
              marginLeft: '8px'
            }}>
              {badgeCount > 99 ? '99+' : badgeCount}
            </span>
          ) : null}
          {badgeText ? (
            <span style={{
              background: badgeColor || '#22c55e',
              color: 'white',
              fontSize: '10px',
              fontWeight: 600,
              padding: '2px 6px',
              borderRadius: '6px',
              marginLeft: '8px'
            }}>
              {badgeText}
            </span>
          ) : null}
          {dot && (
            <span style={{
              width: '8px',
              height: '8px',
              background: '#22c55e',
              borderRadius: '50%',
              marginLeft: '8px',
              flexShrink: 0
            }} />
          )}
        </span>
      )}
      {/* Badge for Collapsed Sidebar */}
      {isSidebarCollapsed && badgeCount && badgeCount > 0 ? (
        <span style={{
          position: 'absolute',
          top: '4px',
          right: '8px',
          background: '#ef4444',
          color: 'white',
          fontSize: '10px',
          fontWeight: 600,
          width: '16px',
          height: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%'
        }}>
          {badgeCount > 9 ? '9+' : badgeCount}
        </span>
      ) : null}
    </Link>
  );
};

export default NavbarButton;
